import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type MarqueeProps = {
  children: ReactNode
  className?: string
  duration?: string
  reverse?: boolean
}

/** Infinite horizontal ticker with faded edges; pauses on hover. */
export function Marquee({ children, className, duration = '40s', reverse = false }: MarqueeProps) {
  return (
    <div
      className={cn(
        'group flex overflow-hidden [--gap:0.75rem] [gap:var(--gap)] [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]',
        className,
      )}
      style={{ ['--duration' as string]: duration }}
    >
      {[0, 1].map((i) => (
        <div
          key={i}
          aria-hidden={i === 1}
          className={cn(
            'flex shrink-0 animate-marquee items-center [gap:var(--gap)] group-hover:[animation-play-state:paused]',
            reverse && '[animation-direction:reverse]',
          )}
        >
          {children}
        </div>
      ))}
    </div>
  )
}
